import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ButtonBasic from "@rentiohq/shared-frontend/dist/components/components/ButtonBasic";
import Spacer, { ESpacerWeight, } from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { useSelector } from "react-redux";
import { Banner } from "../../Banner";
export var InfoField = function (props) {
    var uiSchema = props.uiSchema, formContext = props.formContext, formData = props.formData;
    var _a = uiSchema, icon = _a.icon, subtitle = _a.subtitle, getSubtitle = _a.getSubtitle, actionTitle = _a.actionTitle, type = _a.type, onPressAction = _a.onPressAction;
    // @ts-ignore TODO: Typescript upgrade
    var title = getFieldTitle(uiSchema, formContext);
    var customSubtitle = useSelector(function (state) {
        return subtitle ||
            (!!getSubtitle &&
                getSubtitle(state, formContext.getAllFormData(), formData));
    });
    return (_jsxs(Banner, { title: title, icon: icon, hasDismiss: false, variation: type, children: [!!customSubtitle && (_jsx("span", { style: { whiteSpace: "pre-line" }, children: customSubtitle })), actionTitle && (_jsxs(_Fragment, { children: [_jsx(Spacer, { weight: ESpacerWeight.W04 }), _jsx(ButtonBasic, { title: actionTitle, onPress: onPressAction })] }))] }));
};
